import * as React from "react";
import "./FileBrowser.scss";
import FileBrowser from "./FileBrowser";
export default class FocusFileBrowser extends React.Component {
    constructor(props) {
        super(props);
        this.handleLocationClick = (id) => {
            this.props.onClickedLocation(id);
        };
        let fetchedPaths = [];
        for (let i = 0; i < this.props.rootPaths.length; i++) {
            let name = this.props.rootPaths[i]["name"].charAt(0).toUpperCase() +
                this.props.rootPaths[i]["name"].slice(1);
            let icon = "";
            switch (name) {
                case "Common":
                    icon = "home";
                    break;
                case "Scenario":
                    icon = "applications";
                    break;
                case "Workspace":
                    icon = "manually-entered-data";
                    break;
                case "Incoming":
                    icon = "document-open";
                    break;
                case "Outgoing":
                    icon = "document-share";
                    break;
                default:
                    icon = "folder-open";
            }
            let path = this.props.rootPaths[i]["relativeLocation"];
            if (path.slice(-1) != "/") {
                path = path + "/";
            }
            fetchedPaths.push({
                id: i,
                name: name,
                relativeLocation: path,
                iconName: icon,
            });
        }
        this.state = {
            rootPaths: fetchedPaths,
        };
    }
    render() {
        return (React.createElement(FileBrowser, { isDialogOpen: this.props.isDialogOpen, currentPath: this.props.currentPath, hasLocations: true, extensions: this.props.extensions, elements: this.props.elements, elementsStatus: this.props.elementsStatus, elementsError: this.props.elementsError, rootPaths: this.state.rootPaths, clickedLocation: this.props.clickedLocation, onAccept: this.props.onAccept, onCancel: this.props.onCancel, onClickedLocation: this.handleLocationClick, isReadOnly: this.props.isReadOnly }));
    }
}
//# sourceMappingURL=FocusFileBrowser.js.map